import { createStore, createTypedHooks } from 'easy-peasy';
import { api } from '~/api';
import { authService } from '~/services/auth-service';
import { history } from '~/history';
import { StoreModel } from './StoreModel';
import { authModel } from './store';
import marketplaceModel from './marketplaceModel';
import marketdepthModel from './marketdepthModel';
import notifModel from './notifModel';
import authorisationModel from './AuthorisationModel';

const storeModel: StoreModel = {
  // authModel initialises solutionId/user to null before sign-in; the AuthModel
  // state-shape treats them as always-present, so assert at this single seam.
  auth: authModel as unknown as StoreModel['auth'],
  marketplace: marketplaceModel,
  marketdepth: marketdepthModel,
  notif: notifModel,
  authorisation: authorisationModel,
};

export const store = createStore(storeModel, {
  name: 'NuiStore',
  injections: {
    api,
    authService,
    history,
  },
});

// Wire the api's 401-refresh fallback to the auth store's signOut.
// Fires only after refresh() itself fails, so the user needs to re-auth.
api.onSessionExpired = () => {
  if (!store.getState().auth.user) return;
  if (window.location.pathname === '/signin') return;
  (store.getActions().auth as any).signOut({ preserveUrl: true });
};

// Export typed hooks
export const { useStoreActions, useStoreState, useStoreDispatch } =
  createTypedHooks<StoreModel>();

export { authModel, marketplaceModel, marketdepthModel, notifModel };
